import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { first, map, switchMap } from 'rxjs/operators';
import { DocService } from 'src/app/product-capture/services/doc.service';
import { OpenPreviewModalInput } from './preview-modal.service';
import { from, of } from 'rxjs';

@Component({
  selector: 'app-preview-modal',
  templateUrl: './preview-modal.component.html',
  styleUrls: ['./preview-modal.component.scss'],
})
export class PreviewModalComponent implements OnInit {
  document: OpenPreviewModalInput;
  loading: boolean = true;
  ok: boolean = true;
  documentBase64URL: string;
  whichViewer: 'url' = 'url';

  constructor(
    public modal: NgbActiveModal,
    private docService: DocService
  ) { }

  ngOnInit(): void { }

  setDialogProps(props: OpenPreviewModalInput): void {
    this.loading = true;
    this.ok = true;

    let targetFn = this.docService.getPDFAsBase64;

    const base64PDFHeader = 'data:application/pdf;base64,';

    targetFn.bind(this.docService)(props.documentId)
      .pipe(
        first(), 
        switchMap((base64: any) =>
          from(fetch(base64PDFHeader+base64))
           .pipe(
             map(async res => await res.blob()),
             switchMap(res => from(res)),
             map(blob => URL.createObjectURL(blob)),
           )
        )
      )
      .subscribe(
      (url) => {
        this.documentBase64URL = url;
        this.loading = false;
      },
      (error) => {
        this.ok = false;
        this.loading = false;
        console.error({error});
      }
    );
  }

  close(): void {
    this.modal.close('cancel');
  }
}
